import { Image, Typography } from 'lib/components';
import { ImageSource } from 'lib/components/types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './index.module.scss';

/**
 * Props interface for the Tab component
 */
interface Props {
	/** URL path to navigate to when tab is clicked */
	to: string;
	/** Icon source to display in the tab */
	iconSrc: ImageSource;
	/** Text label to display in the tab */
	label: string;
}

/**
 * Tab component
 * Renders a navigation tab for the settings screen
 * Includes an icon and label, and uses NavLink for active state styling
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const Tab = ({ to, iconSrc, label }: Props) => {
	return (
		<NavLink to={to} className={classes['settings-tabLink']} activeClassName={classes['settings-tabLinkActive']}>
			<div className={classes['settings-tab']}>
				{/* Tab icon */}
				<div className={classes['settings-tab-icon']}>
					<Image src={iconSrc} />
				</div>
				{/* Tab label */}
				<Typography variant="h3" className={classes['settings-tab-label']}>
					{label}
				</Typography>
			</div>
		</NavLink>
	);
};

export default Tab;
